import React from "react";
import { fetchAddEmployee, fetchEditEmployee } from "../../../../api/employee";
import { Form, Input, Modal, Select, message } from "antd";
import { Encrypt } from "../../../../utils/secret";

const formItemLayout = {
  labelCol: {
    xs: { span: 12 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 36 },
    sm: { span: 18 },
  },
};
const { Option } = Select;
class EditEmployee extends React.Component {
  handleOk = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        let data = Encrypt(
          JSON.stringify({
            ...values,
            type: "SYSTEM",
          })
        );
        fetchAddEmployee(data).then((res) => {
          if (res.success) {
            message.success("新增成功");
            this.props.handleCancel();
            this.props.getEmployeeList();
          }
        });
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { visible, handleCancel } = this.props;
    return (
      <Modal
        destroyOnClose={true}
        title={"新增人员"}
        visible={visible}
        onOk={this.handleOk}
        onCancel={handleCancel}
      >
        <Form onSubmit={this.handleOk} {...formItemLayout}>
          <Form.Item label="人员姓名">
            {getFieldDecorator("name", {
              rules: [{ required: true, message: "请输入联系人姓名" }],
            })(<Input placeholder="请输入联系人姓名" />)}
          </Form.Item>
          <Form.Item label="系统账号">
            {getFieldDecorator("mobilePhone", {
              rules: [{ required: true, message: "请输入用作账号的手机号码" }],
            })(<Input placeholder="请输入用作账号的手机号码" />)}
          </Form.Item>
          <Form.Item label="密码">
            {getFieldDecorator("password", {
              rules: [
                { required: true, message: "请输入6位数密码" },
                { len: 6, message: "密码只能为6位数！" },
              ],
            })(<Input placeholder="请输入6位数密码" />)}
          </Form.Item>
        </Form>
      </Modal>
    );
  }
}

export default Form.create()(EditEmployee);
